export type UtilityChargebackAvailability = {
  billBacked: boolean
  orphaned: boolean
}

export const getUtilityChargebackAvailability = ({
  canCreateLiabilities,
  canCreateOrphanedChargebacks,
  canEditLedger,
  isLedgerLocked,
  portfolioHomeId
}: {
  canCreateLiabilities: boolean
  canCreateOrphanedChargebacks: boolean
  canEditLedger: boolean
  isLedgerLocked: boolean
  portfolioHomeId?: string | null
}): UtilityChargebackAvailability => ({
  billBacked: !isLedgerLocked && canCreateLiabilities && canEditLedger && Boolean(portfolioHomeId),
  orphaned: !isLedgerLocked && canCreateOrphanedChargebacks
})
